function SystemSettingCtrl($auth, toaster, $state, SystemSettingService, CommonService) {
  'ngInject';
  // ViewModel
  
  const vm = this;
  vm.loading = false;
  vm.dataLoading = false;
  vm.systemSetting = {};
  vm.retrieveError = false;
  vm.periodLoading = false;
  vm.dayPicker = [...Array(28).keys()].map(x => ++x);

  vm.init = function() {
    vm.dataLoading = true;
    SystemSettingService.systemSetting(function(response) {
      vm.dataLoading = false;
      if (response.status == 200) {
        vm.retrieveError = false;
        vm.systemSetting = response.data;
      } else {
        vm.retrieveError = true;
      }
    });
  };

  vm.buttonText = function() {
    return `${vm.systemSetting.auto_bulk_sync ? 'Disable ' : 'Enable' } Auto Run`;
  };

  vm.saveSystemSetting = function(){
    vm.periodLoading = true;
    let benchmarkData = {
      'benchmark_rolling_period': vm.systemSetting['benchmark_rolling_period'], 
      'benchmark_start_day': vm.systemSetting['benchmark_start_day']
    };
    SystemSettingService.saveSystemSetting(benchmarkData, function(response) {
      vm.periodLoading = false;
      if (response.status == 200) {
        vm.systemSetting = response.data.data;
        toaster.pop('info', 'Rolling period updated successfully.');
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.toggleBulkSync = function() {
    swal({
          title: 'Are you sure?',
          text: `You are switching auto run bulk cost calculator ${vm.systemSetting.auto_bulk_sync ? 'off' : 'on' }.`,
          icon: 'warning',
          dangerMode: true,
          buttons: [true, true]
        })
        .then(willDelete => {
          if (willDelete) {
            SystemSettingService.toggleBulkCost(function(response) {
              vm.loading = false;
              if (response.status == 200) {
                vm.systemSetting.auto_bulk_sync = !vm.systemSetting.auto_bulk_sync;
                toaster.pop('info', `Auto run bulk cost calculator turned ${vm.systemSetting.auto_bulk_sync ? 'on' : 'off' } successfully.`);
              } else {
                toaster.pop('error', CommonService.throwError(response));
              }
            });
          } else {
            vm.loading = false;
          }
        });
  };
  
}
export default {
  name: 'SystemSettingCtrl',
  fn: SystemSettingCtrl
};
